import React from 'react';
import PropTypes from 'prop-types';

import FixedHeader from '@components/FixedHeader';
import InnerHeader from '@components/InnerHeader';
import MagicHeader from '@components/MagicHeader';
import useIsDesktopLayout from '@hooks/useIsDesktopLayout';

function Header({
  label,
  onClose,
  actionLabel,
  onActionClick,
  isModal,
  subtitle,
  shadow,
  icon,
  withLogo,
}) {
  const isDesktopLayout = useIsDesktopLayout();
  return (
    <>
      {!isDesktopLayout ? (
        <MagicHeader
          mainHeader={
            <InnerHeader
              label={label}
              onClose={onClose}
              actionLabel={actionLabel}
              onActionClick={onActionClick}
              isModal={isModal}
              subtitle={subtitle}
              icon={icon}
            />
          }
          secondHeader={
            <FixedHeader
              onClose={onClose}
              label={label}
              actionLabel={actionLabel}
              onActionClick={onActionClick}
              isModal={isModal}
              shadow={shadow}
            />
          }
        />
      ) : (
        <FixedHeader
          onClose={onClose}
          label={label}
          actionLabel={actionLabel}
          onActionClick={onActionClick}
          isModal={isModal}
          withLogo={withLogo}
        />
      )}
    </>
  );
}

Header.defaultProps = {
  isModal: false,
  withLogo: false,
  shadow: true,
};

Header.propTypes = {
  label: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  actionLabel: PropTypes.string,
  onActionClick: PropTypes.func,
  isModal: PropTypes.bool,
  subtitle: PropTypes.string,
  icon: PropTypes.string,
  withLogo: PropTypes.bool,
  shadow: PropTypes.bool,
};

export default Header;
